export default function ContentNinth({ verticalTabsState }) {
  return (
    <div
      className={`content-9 overflow-hidden max-h-0 transition-opacity duration-[0.2s] ease-linear ${
        verticalTabsState === 9
          ? "max-h-[5000px] opacity-100 z-2"
          : "opacity-0 max-h-0 z-0"
      }`}
    >
      <h1 className="font-mont text-[36px] leading-[40px] my-[0.67em]">
        <strong>Fleet Management</strong>
      </h1>

      <p className="text-[16px] leading-[28px] mb-[25px]">
        Manage your vehicles, contracts, costs, insurances and assignments
        without pain.
      </p>

      <h2 className="text-[30px] leading-[40px] font-mont mt-5 mb-[10px]">
        <strong>Fleet Management Made Easy</strong>
      </h2>

      <p className="mb-5 text-[16px]">
        You won't need any specialized tracking system for company vehicles. You
        can keep a close eye on your fleet in a few simple clicks. Manage
        everything through our user-friendly administrative system - fuel log
        entries, costs and many other features necessary for the management of
        your company's vehicles.
      </p>

      <h2 className="text-[30px] leading-[40px] font-mont mt-5 mb-[10px]">
        <strong>Manage Leasing And All Other Contracts</strong>
      </h2>

      <p className="mb-5 text-[16px]">
        Supervise all contracts for your vehicles and receive a warning email
        when contracts reach their expiration date. Several visual tools are put
        in place to ensure that you'll remember to renew (or end) your contract.
        Organize the services around the vehicles and communicate with the
        qualified service providers; manage invoices and notes. Set up a vehicle
        policy within your company, as well as an insurance policy in order to
        manage your fleet in the most efficient way.
      </p>

      <h2 className="text-[30px] leading-[40px] font-mont mt-5 mb-[10px]">
        <strong>Monitor All Costs At Once</strong>
      </h2>

      <p className="mb-5 text-[16px]">
        Identify and trace the money spent by your company for each of the fleet
        vehicles. Recurring costs of your contracts such as leasing and services
        contracts are automatically added to your accounting at the beginning of
        each period of the frequency specified in the contracts, while all other
        costs like fuel and repairs are automatically added to your report.
      </p>

      <h2 className="text-[30px] leading-[40px] font-mont mt-5 mb-[10px]">
        <strong>Analysis And Reporting</strong>
      </h2>

      <p className="mb-5 text-[16px]">
        Show all costs associated with a given vehicle or with a type of
        service. Compare different types of costs (which vehicles cost the most;
        which services have been performed on which vehicles; etc) by using the
        reporting tool. Get really helpful insights about the effective return
        of each vehicle in order to improve your fleet investments.
      </p>
    </div>
  );
}
